export default __webpack_public_path__ + "static/media/136-tile.b83339d7.svg";